import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { ModalPage } from '../../components/layout'
import { ScheduleAppointment } from '../../components/schedule/New'
import {
  ClickTrackingProvider,
  FormAnalyticsProvider,
  IsManualModeProvider,
  SchedulingModeProvider,
  SessionDurationProvider,
} from '../../hooks'
import { AppointmentFormData } from '../../types'

const Index = () => (
  <SchedulingModeProvider>
    <SessionDurationProvider>
      <ClickTrackingProvider>
        <FormAnalyticsProvider<AppointmentFormData>>
          <IsManualModeProvider>
            <ScheduleAppointment />
          </IsManualModeProvider>
        </FormAnalyticsProvider>
      </ClickTrackingProvider>
    </SessionDurationProvider>
  </SchedulingModeProvider>
)

const SchedulePage = () => (
  <ModalPage>
    <Routes>
      <Route element={<Index />} path="/" />
      <Route element={<NotFound />} path="*" />
    </Routes>
  </ModalPage>
)

const AuthenticatedSchedule = withAuthenticationRequired(SchedulePage)

export { AuthenticatedSchedule as Schedule }
